import { useContext } from "react";
import "../common/elements/Header.scss";
import AppBar from "@/features/common/elements/AppBar";
import MainSideNavBar from "@/features/common/elements/MainSideNavBar";
import { Institution } from "../common/interfaces/Interface";
import { sendRequestWithPayload } from "../../common/http";
import { ToolboxChat } from "@watermarkinsights/ai-toolbox";
import { AiChatWidget } from "./ai-chat/AiChatWidget";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";

const { TOOLBOX_FEATURE_ID, TOOLBOX_PRODUCT } = runConfig;

export const PlanningHeaderSidebar = ({
  institution,
  componentLoaded,
  children,
  showAiChat = false,
}: {
  institution: Institution;
  componentLoaded: {
    selectedTab: string;
    collapseSideNav: boolean;
    openPreviewModal: boolean;
    institution: boolean;
    membership: boolean;
  };
  children: JSX.Element;
  showAiChat?: boolean;
}) => {
  const { setAiChatToggleVisible } = useContext<AppContextInterface>(AppContext);
  const mainContent = <div className="contentwrapper">{children}</div>;

  return (
    <div className="pagewrapper">
      {institution && <AppBar institution={institution} />}
      <div className="nav-main">
        {institution && (
          <MainSideNavBar
            institution={institution}
            collapseSideNav={componentLoaded.collapseSideNav}
          />
        )}
        <ToolboxChat
          featureId={TOOLBOX_FEATURE_ID}
          product={TOOLBOX_PRODUCT}
          sessionUrl={() =>
            new Promise((resolve, reject) => {
              sendRequestWithPayload(
                { uri: "/home/toolbox-session", camelize: true },
                (result: any) => {
                  if (result?.sessionId) {
                    setAiChatToggleVisible(true);
                    resolve(result);
                  } else {
                    setAiChatToggleVisible(false);
                    reject(result);
                  }
                },
                (error: any) => {
                  setAiChatToggleVisible(false);
                  reject(error);
                },
              );
            })
          }
          fallback={mainContent}
        >
          {mainContent}
          {showAiChat && <AiChatWidget />}
        </ToolboxChat>
      </div>
    </div>
  );
};
